const UnderConstruction = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-100">
            <h1 className="text-4xl font-bold text-gray-800">🚧 Under Construction 🚧</h1>
            <p className="text-lg text-gray-600 mt-4">We're working hard to bring you this page soon!</p>
        </div>
    );
};

export default UnderConstruction;
